<template>
  <div class="container">
     <div class="row p-0 m-0">
        <div class="col-12 col-lg-10 p-0 m-auto">
          <h2>{{ $t('cartapresidente.carta_del') }}</h2>
          <img :src="`${publicPath}img/presidente.jpg`" data-aos="fade" data-aos-duration="1200" class="img-responsive my-3">
          <h4 class="myriadPro">JUAN ECHEVARRÍA PUIG</h4>
          <p class="myriadPro text-black"><strong>{{ $t('cartapresidente.title') }}</strong></p>
          <img :src="`${publicPath}img/Grupo 1703.png`" class="img-responsive my-3">
          <div class="col-12 col-lg-7 mb-5 m-auto">
            <h6 class="myriadPro">{{ $t('cartapresidente.las_mutuas') }}</h6>
          </div>
          <hr class="filigrana  mb-3">
          <div class="col-12 col-lg-10 m-auto text-start">
            <p class=" text-black">{{ $t('cartapresidente.inicio') }}</p>
          <p class=" text-black">{{ $t('cartapresidente.transcurrir') }}</p>
          <p class=" text-black">{{ $t('cartapresidente.creiamos') }}</p>
          <p class=" text-black">{{ $t('cartapresidente.economicamente') }}</p>
            <p class=" text-black">{{ $t('cartapresidente.contexto') }}</p>
          <p class=" text-black">{{ $t('cartapresidente.pib') }}</p>
          <p class=" text-black">{{ $t('cartapresidente.inflacion') }}</p>
          <p class=" text-black">{{ $t('cartapresidente.seguridad_social') }}</p>
          <p class=" text-black">{{ $t('cartapresidente.escenario') }}</p>
            <div class="col-12 col-lg-7 mb-5 m-auto text-center">
              <img :src="`${publicPath}img/Grupo 1703.png`" class="img-responsive my-3">
              <h6 class="myriadPro">{{ $t('cartapresidente.reconocimiento') }}</h6>
            </div>
            <hr class="filigrana">
            <p class=" text-black">{{ $t('cartapresidente.responsabilidad') }}</p>
          <p class=" text-black">{{ $t('cartapresidente.ambito') }}</p>
          <p class=" text-black">{{ $t('cartapresidente.garn_medida') }}</p>
          <p class=" text-black">{{ $t('cartapresidente.desde_aqui') }}</p>
          <p class=" text-black">{{ $t('cartapresidente.profesionales') }}</p>
          <p>
            <img :src="`${publicPath}img/firma_Juan_echevarria.jpg`" class="img-responsive my-3" style="max-width: 291px">
          </p>
          <h4 class="myriadPro ">JUAN ECHEVARRÍA PUIG</h4>
          <p class="myriadPro  text-black mb-5"><strong>{{ $t('cartapresidente.title') }}</strong></p>
          </div>
        </div>

       <!-- NAVEGACIÓ PRE-FOOTER -->
       <hr>
       <div class="row p-0 g-0 mb-3">
         <div class="col-6 p-0 m-0 pb-3 text-start">
           <localized-link class="footerLink" to="/cartas"><img :src="`${publicPath}img/arrowLeft.png`" class="img-responsive arrowsFooter"> {{ $t("nav.cartas") }}</localized-link>
         </div>
         <div class="col-6 p-0 m-0 pb-3 text-end textSmall">
           <localized-link class="footerLink" to="/cartas/carta-del-director-gerente"> {{ $t("nav.carta-del-director-gerente") }} <img :src="`${publicPath}img/arrowRight.png`" class="img-responsive arrowsFooter"></localized-link>
         </div>
       </div>

     </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      publicPath: process.env.BASE_URL
    }
  }
}
</script>
